import useSWR from 'swr';

import { useViewer } from '@vimeo/viewer';

import { getReferrerValue, getSearchParams, serializeQuery, showcaseAuthFetcher } from '../helper';
import { ShowcaseAuthError, ShowcaseAuthResponse } from '../types/types';

export const useShowcaseAuth = (
  albumIdOrUrl: string | number,
  options: { isShowcaseEmbedded?: boolean },
  notCallable: boolean = false,
) => {
  const viewer = useViewer();
  const sh = getSearchParams().get('sh'); // album hash

  return useSWR<ShowcaseAuthResponse, ShowcaseAuthError>(
    () => {
      if (!viewer || notCallable) return null;

      const authQueryParams = {
        ...(sh && { sh }),
        ...(options?.isShowcaseEmbedded && {
          referrer: encodeURIComponent(getReferrerValue() || ''),
          is_embed: true,
        }),
      };

      /**
       * This is not Vimeo API endpoint, hence no GCTL hook generated, use SWR directly
       * Ref: https://github.com/vimeows/vimeo/blob/f054bd8cee34386203217ef0b28718bcef8b53f8/routes/main.php#L4565-L4569
       */
      const authUrl = albumIdOrUrl
        ? `/showcase/${albumIdOrUrl}/auth${serializeQuery(authQueryParams)}`
        : '/auth'; // For showcase custom domain, such as "http://vodcontainer.com/", there won't be a albumIdOrUrl

      return authUrl;
    },
    showcaseAuthFetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );
};
